import { useState, useEffect } from 'react';
import { FaHome } from "react-icons/fa";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import API_URL from '../config';

import {
  FaUser,
  FaBriefcase,
  FaBookmark,
  FaBell,
  FaFileUpload,
  FaSignOutAlt,
  FaMapMarkerAlt,
  FaHospital,
  FaClock,
  FaBars,
  FaTimes,
  FaCheckCircle,
  FaFileAlt,
  FaBuilding,
  FaMoneyBillWave,
  FaEye,
  FaTrashAlt,
  FaTimesCircle,
  FaExternalLinkAlt
} from 'react-icons/fa';

function CandidateDashboard() {

const [user] = useState(() => {
  try {
    return JSON.parse(localStorage.getItem('user'));
  } catch {
    return null;
  }
});

const navigate = useNavigate();

useEffect(() => {
  if (!user) {
    navigate('/login', { replace: true });
  }
}, [user, navigate]);

  const [activeTab, setActiveTab] = useState('dashboard');
  const [profileTab, setProfileTab] = useState('myProfile');


  const [currentPassword, setCurrentPassword] = useState("");
const [newPassword, setNewPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [changePasswordLoading, setChangePasswordLoading] = useState(false);

const [changePasswordMessage, setChangePasswordMessage] = useState("");
const [changePasswordMessageType, setChangePasswordMessageType] = useState("");

  const [profile, setProfile] = useState({
    qualification: '',
    experience_years: '',
    skills: '',
    location: '',
    bio: ''
  });

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [resumeUrl, setResumeUrl] = useState("");

  const [applications, setApplications] = useState([]);
  const [profilePic, setProfilePic] = useState("");
const [selectedApplication, setSelectedApplication] =
  useState(null);
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const fetchNotifications = async () => {
  if (!user?.id) return;

  try {
    const res = await axios.get(
      `${API_URL}/notifications/${user.id}`
    );

    setNotifications(res.data);
  } catch (err) {
    console.error(
      'Error fetching notifications:',
      err.response?.data || err.message
    );
  }
};
useEffect(() => {
  if (user?.id && activeTab === 'notifications') {
    fetchNotifications();
  }
}, [user?.id, activeTab]);


  const [allJobs, setAllJobs] = useState([]);
  const recommendedJobs = allJobs
  .filter((job) => {
    if (job.status && job.status.toLowerCase() !== "active") {
      return false;
    }

    if (job.expires_at && new Date(job.expires_at) < new Date()) {
      return false;
    }

    return true;
  })
  .map((job) => {
    const jobText = [
      job.role,
      job.title,
      job.description,
      job.skills,
      job.requirements,
      job.qualification,
      job.experience,
      job.job_type,
      job.category,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    const candidateSkills = (profile.skills || "")
      .split(/[,;|\n]+/)
      .map((skill) => skill.trim().toLowerCase())
      .filter(Boolean);

    const qualification = (profile.qualification || "").trim().toLowerCase();
    const location = (profile.location || "").trim().toLowerCase();

    const matchedSkills = candidateSkills.filter((skill) =>
      jobText.includes(skill)
    );

    const qualificationMatch =
      qualification.length > 0 && jobText.includes(qualification);

    const locationMatch =
      location.length > 0 &&
      (job.location || "").toLowerCase().includes(location);

    const score =
      matchedSkills.length * 3 +
      (qualificationMatch ? 2 : 0) +
      (locationMatch ? 1 : 0);

    return { ...job, recommendationScore: score };
  })
  .filter((job) => job.recommendationScore > 0)
  .sort((a, b) => b.recommendationScore - a.recommendationScore)
  .slice(0, 6);
  
const fetchAllJobs = async () => {
  try {
    const res = await axios.get(
      `${API_URL}/jobs/all`
    );

    setAllJobs(Array.isArray(res.data) ? res.data : []);
  } catch (err) {
    console.error("Error fetching recommended jobs:", err);
    setAllJobs([]);
  }
};


  
  const fetchApplications = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/applications/candidate/${user.id}`
    );

    setApplications(res.data);

setAppliedJobs(
  res.data.map(app => app.job_id)
);

  } catch (err) {

    console.log(err);
  }
};

useEffect(() => {

fetchApplications();
fetchSavedJobs();
fetchProfile();
fetchAllJobs();
fetchResume();

}, []);
const [savedJobs, setSavedJobs] = useState([]);
const fetchSavedJobs = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/saved-jobs/${user.id}`
    );

    setSavedJobs(res.data);

  } catch (err) {

    console.log(err);
  }
};
// ===============================
// PROFILE COMPLETION
// ===============================
const profileCompletionFields = [
  user?.name,
  user?.email,
  profile.qualification,
  profile.experience_years,
  profile.skills,
  profile.location,
  profile.bio,
  resumeUrl,
  profilePic
];

const profileCompletion = Math.round(
  (profileCompletionFields.filter(
    value => value && String(value).trim() !== ''
  ).length / profileCompletionFields.length) * 100
);
const handleNotificationClick = async (notification) => {
  console.log("Clicked notification:", notification);

  const applicationId = Number(notification.application_id);

  if (!applicationId) {
    alert(
      "This notification has no linked application. Please use a newer notification."
    );
    return;
  }

  try {
    // Always fetch the latest application records.
    const res = await axios.get(
      `${API_URL}/applications/candidate/${user.id}`
    );

    const latestApplications = Array.isArray(res.data)
      ? res.data
      : [];

    console.log("Applications returned by API:", latestApplications);
    console.log("Looking for application ID:", applicationId);

    setApplications(latestApplications);

    const application = latestApplications.find(
      (app) => Number(app.id) === applicationId
    );

    if (!application) {
      console.error(
        "Application ID not found:",
        applicationId
      );
      alert(
        `Application ID ${applicationId} was not found in your applications.`
      );
      return;
    }

    setSelectedApplication(application);

    // Ensure the application details section is visible.
    document
      .getElementById("selected-application-card")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  } catch (err) {
    console.error(
      "Error opening notification application:",
      err.response?.data || err.message || err
    );
    alert("Unable to load the application. Check the browser Console.");
  }
};

const applyJob = async (jobId) => {

  try {

    await axios.post(
      '${API_URL}/applications/apply',
      {
        job_id: jobId,
        candidate_id: user.id
      }
    );

    alert('Applied Successfully');
    fetchApplications();

  } catch (err) {

    console.log(err);

    alert('Error applying');
  }
};
const saveJob = async (jobId) => {

  try {

    await axios.post(
      '${API_URL}/saved-jobs/save',
      {
        candidate_id: user.id,
        job_id: jobId
      }
    );

    fetchSavedJobs();

    alert('Job saved');

  } catch (err) {

    alert('Already saved');
  }
};
const removeSavedJob = async (savedJobId) => {

  try {

    await axios.delete(
      `${API_URL}/saved-jobs/${savedJobId}`
    );

    alert("Job removed successfully");

    fetchSavedJobs();

  } catch (err) {

    console.log(err);

    alert("Error removing saved job");

  }

};

const handleResumeUpload = async (e) => {

  const file = e.target.files[0];

  if (!file) return;

  const formData = new FormData();

  formData.append('resume', file);

  try {

    const res = await axios.post(
      `${API_URL}/upload/resume/${user.id}`,
      formData
    );

setResumeUrl(
  res.data.resume_url
);

alert("Resume uploaded successfully");
  } catch (err) {

    console.log(err);

    alert('Upload failed');

  }
};
// ===============================
// LOAD PROFILE
// ===============================
const fetchProfile = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/candidates/profile/${user.id}`
    );

    setProfile({
      qualification: res.data.qualification || '',
      experience_years: res.data.experience_years || '',
      skills: res.data.skills || '',
      location: res.data.location || '',
      bio: res.data.bio || ''
    });
    setProfilePic(
  res.data.profile_pic || ""
);

  } catch (err) {

    console.log(err);

  }

};
const fetchResume = async () => {

  try {

    const res = await axios.get(
      `${API_URL}/auth/user/${user.id}`
    );

    setResumeUrl(
      res.data.resume_url || ""
    );

  } catch (err) {

    console.log(err);

  }

};

// ===============================
// HANDLE INPUT CHANGE
// ===============================
const handleProfileChange = (e) => {

  setProfile({
    ...profile,
    [e.target.name]: e.target.value
  });

};

// ===============================
// SAVE PROFILE
// ===============================
const handleProfileSave = async () => {

  try {
    if (profilePicFile) {

  const formData = new FormData();

  formData.append(
    "photo",
    profilePicFile
  );

  const uploadRes = await axios.post(
    `${API_URL}/profile/upload-photo/${user.id}`,
    formData
  );

  setProfilePic(
    uploadRes.data.profile_pic
  );

}
    await axios.post(
      `${API_URL}/candidates/profile`,
      {
        user_id: user.id,
        qualification: profile.qualification,
        experience_years: profile.experience_years,
        skills: profile.skills,
        location: profile.location,
        bio: profile.bio
      }
    );

    alert("Profile Saved Successfully");
    await fetchProfile();

  } catch (err) {

    console.log(err);

    alert("Error Saving Profile");

  }

};
// ===============================
// CHANGE PASSWORD
// ===============================
// ===============================
// CHANGE PASSWORD
// ===============================
const handleChangePassword = async () => {

  // Clear previous message
  setChangePasswordMessage("");
  setChangePasswordMessageType("");


  if (!currentPassword || !newPassword || !confirmPassword) {

    setChangePasswordMessage(
      "Please fill all password fields."
    );

    setChangePasswordMessageType("error");

    return;
  }


  if (newPassword !== confirmPassword) {

    setChangePasswordMessage(
      "New password and confirm password do not match."
    );

    setChangePasswordMessageType("error");

    return;
  }


  if (newPassword.length < 8) {

    setChangePasswordMessage(
      "New password must be at least 8 characters long."
    );

    setChangePasswordMessageType("error");

    return;
  }


  try {

    setChangePasswordLoading(true);


    const res = await axios.post(
      `${API_URL}/auth/change-password`,
      {
        userId: user.id,
        currentPassword,
        newPassword,
        confirmPassword
      }
    );


    // SUCCESS
    setChangePasswordMessage(
      res.data.message || "Password changed successfully."
    );

    setChangePasswordMessageType("success");


    // Clear password fields
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");


  } catch (err) {

    console.log(
      "CHANGE PASSWORD ERROR:",
      err
    );


    setChangePasswordMessage(
      err.response?.data?.message ||
      "Unable to change password."
    );

    setChangePasswordMessageType("error");


  } finally {

    setChangePasswordLoading(false);

  }
};

  return (

<div className="min-h-screen bg-gray-100 flex lg:h-screen lg:overflow-hidden">
      <style>{`
        /* Scrollbars remain visible on mobile and are hidden on desktop. */
        @media (min-width: 1024px) {
          .dashboard-no-scrollbar { scrollbar-width: none; -ms-overflow-style: none; }
          .dashboard-no-scrollbar::-webkit-scrollbar { display: none; width: 0; height: 0; }
        }
        @media (max-width: 1023px) {
          .dashboard-mobile-scroll { overflow-y: auto; -webkit-overflow-scrolling: touch; }
        }
      `}</style>

      {/* SIDEBAR */}
      <div className="hidden lg:block lg:sticky lg:top-0 lg:h-screen lg:overflow-y-auto dashboard-no-scrollbar shrink-0 w-72 bg-gradient-to-b from-teal-700 to-emerald-800 text-white p-6">

        {/* PROFILE */}
        <div className="mb-6 sm:mb-8 lg:mb-10">

          <div className="flex items-center gap-4">

            <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center text-lg sm:text-xl lg:text-2xl font-bold">
              {user.name?.charAt(0)}
            </div>

            <div>

              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold">
                {user.name}
              </h2>

              <p className="text-teal-100">
                Healthcare Professional
              </p>

            </div>

          </div>

        </div>

        {/* MENU */}
        <div className="space-y-3">

          <button
            onClick={() => setActiveTab('dashboard')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'dashboard'
                ? 'bg-white text-teal-700'
                : 'hover:bg-white/10'
            }`}
          >
            <FaBriefcase />
            Dashboard
          </button>
          <button
  onClick={() => navigate("/")}
  className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'home'
                ? 'bg-white text-teal-700'
                : 'hover:bg-white/10'
            }`}
          >
 <FaHome />
  Home
</button>

          <button
            onClick={() => setActiveTab('applications')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'applications'
                ? 'bg-white text-teal-700'
                : 'hover:bg-white/10'
            }`}
          >
            <FaHospital />
            My Applications
          </button>

          <button
            onClick={() => setActiveTab('saved')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'saved'
                ? 'bg-white text-teal-700'
                : 'hover:bg-white/10'
            }`}
          >
            <FaBookmark />
            Saved Jobs
          </button>

          <button
            onClick={() => setActiveTab('profile')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'profile'
                ? 'bg-white text-teal-700'
                : 'hover:bg-white/10'
            }`}
          >
            <FaUser />
            Profile
          </button>

          <button
            onClick={() => setActiveTab('resume')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'resume'
                ? 'bg-white text-teal-700'
                : 'hover:bg-white/10'
            }`}
          >
            <FaFileUpload />
            Resume
          </button>

          <button
            onClick={() => setActiveTab('notifications')}
            className={`w-full flex items-center gap-3 p-4 rounded-2xl transition ${
              activeTab === 'notifications'
                ? 'bg-white text-teal-700'
                : 'hover:bg-white/10'
            }`}
          >
            <FaBell />
            Notifications
          </button>

          <button
            onClick={() => {
              localStorage.removeItem('user');
              window.location.href = '/';
            }}
            className="w-full flex items-center gap-3 p-4 rounded-2xl hover:bg-red-500 transition mt-10"
          >
            <FaSignOutAlt />
            Logout
          </button>
          

        </div>

      </div>


      {/* MAIN CONTENT */}
      {/* Mobile header — branded to match the other HireCura dashboards */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 flex items-center justify-between border-b border-slate-200 bg-white/95 px-4 py-3 shadow-sm backdrop-blur">
        <button
          type="button"
          aria-label="Open navigation menu"
          onClick={() => setMobileMenuOpen(true)}
          className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-xl text-teal-700 transition hover:bg-teal-100 active:scale-95"
        >
          <FaBars />
        </button>

        <div className="flex min-w-0 flex-col items-center">
          <h2 className="whitespace-nowrap text-lg font-extrabold leading-none tracking-tight">
            <span className="text-slate-900">Hire</span><span className="text-teal-600">Cura</span>
          </h2>
          <span className="mt-1 whitespace-nowrap text-[10px] font-medium tracking-[0.12em] text-slate-500">
            Where Careers Meet Care.
          </span>
          <span className="mt-1 text-[9px] font-semibold uppercase tracking-[0.18em] text-teal-700">
            Candidate Portal
          </span>
        </div>

        <div className="h-11 w-11 shrink-0" aria-hidden="true" />
      </div>
      <div className="flex-1 min-w-0 w-full overflow-x-hidden dashboard-mobile-scroll px-3 py-4 sm:px-5 lg:p-8 pt-20 sm:pt-24 lg:pt-8 lg:h-screen lg:overflow-y-auto lg:dashboard-no-scrollbar">
      {mobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-slate-950/35 z-[60]"
          onClick={() => setMobileMenuOpen(false)}
        >
          <aside
            className="w-[min(20rem,88vw)] bg-gradient-to-b from-teal-700 to-emerald-800 text-white h-full shadow-2xl px-5 py-6 overflow-y-auto dashboard-mobile-scroll flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Profile header — matches Institution Dashboard menu */}
            <div className="flex justify-between items-center gap-3 mb-7 pb-6 border-b border-white/15">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-14 h-14 rounded-2xl bg-white/90 overflow-hidden border border-white/30 shrink-0 flex items-center justify-center">
                  {profilePic ? (
                    <img
                      src={`${API_URL.replace('/api', '')}/${profilePic}`}
                      alt="Profile"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <FaHospital className="text-2xl text-teal-700" />
                  )}
                </div>
                <div className="min-w-0">
                  <h2 className="font-bold text-lg text-white truncate">{user.name || 'Candidate'}</h2>
                  <p className="text-sm text-teal-100">Healthcare Professional</p>
                </div>
              </div>
              <button
                type="button"
                aria-label="Close navigation menu"
                onClick={() => setMobileMenuOpen(false)}
                className="w-10 h-10 shrink-0 inline-flex items-center justify-center rounded-xl text-white/90 hover:bg-white/10 text-xl transition"
              >
                <FaTimes />
              </button>
            </div>

            <p className="px-3 mb-4 text-xs font-bold tracking-[0.16em] uppercase text-teal-100/80">Workspace</p>
            <nav className="flex-1 space-y-2">
              {[
                { id: 'dashboard', label: 'Dashboard', icon: <FaBriefcase /> },
                { id: 'home', label: 'Home', icon: <FaHome />, action: () => navigate('/') },
                { id: 'applications', label: 'My Applications', icon: <FaHospital /> },
                { id: 'saved', label: 'Saved Jobs', icon: <FaBookmark /> },
                { id: 'profile', label: 'Profile', icon: <FaUser /> },
                { id: 'resume', label: 'Resume', icon: <FaFileUpload /> },
                { id: 'notifications', label: 'Notifications', icon: <FaBell /> }
              ].map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => {
                    if (item.action) item.action();
                    else setActiveTab(item.id);
                    setMobileMenuOpen(false);
                  }}
                  className={`w-full min-h-12 flex items-center gap-3 px-4 py-3 rounded-2xl text-left font-medium transition duration-200 ${
                    activeTab === item.id
                      ? 'bg-white text-teal-800 shadow-sm'
                      : 'text-white hover:bg-white/10'
                  }`}
                >
                  <span className={`w-8 h-8 shrink-0 flex items-center justify-center text-lg ${
                    activeTab === item.id ? 'text-teal-700' : 'text-white'
                  }`}>{item.icon}</span>
                  <span className="flex-1 text-base">{item.label}</span>
                  {activeTab === item.id && <span className="w-2 h-2 rounded-full bg-teal-600" />}
                </button>
              ))}
            </nav>

            <div className="mt-8 pt-5 border-t border-white/15">
              <button
                type="button"
                onClick={() => { localStorage.removeItem('user'); window.location.href = '/'; }}
                className="w-full min-h-12 flex items-center gap-3 px-4 py-3 rounded-2xl text-white hover:bg-red-500/90 transition font-medium"
              >
                <FaSignOutAlt className="text-lg" />
                <span className="text-base">Logout</span>
              </button>
            </div>
          </aside>
        </div>
      )}

            {/* DASHBOARD */}
        {activeTab === 'dashboard' && (
          <div className="w-full min-w-0">
            {/* MOBILE DASHBOARD — mobile-only design */}
            <div className="md:hidden space-y-6 pb-4">
              <section className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-teal-700 via-teal-600 to-emerald-600 p-5 text-white shadow-lg">
                <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-white/10" />
                <div className="absolute -right-2 bottom-[-2.5rem] h-28 w-28 rounded-full bg-white/10" />
                <div className="relative z-10">
                  <p className="text-xs font-semibold uppercase tracking-[0.18em] text-teal-100">Candidate dashboard</p>
                  <h1 className="mt-3 break-words text-2xl font-extrabold leading-tight">
                    Welcome back, {user.name} 
                  </h1>
                  <p className="mt-2 max-w-xs text-sm leading-6 text-teal-50">
                    Discover healthcare opportunities and keep your career moving forward.
                  </p>
                  <button
                    type="button"
                    onClick={() => setActiveTab('applications')}
                    className="mt-5 inline-flex items-center gap-2 rounded-xl bg-white px-4 py-2.5 text-sm font-bold text-teal-700 shadow-sm transition active:scale-[0.98]"
                  >
                    <FaBriefcase /> Track applications <span aria-hidden="true">→</span>
                  </button>
                </div>
              </section>

              {/* Mobile stats */}
              <section>
                <div className="mb-3 flex items-center justify-between gap-3">
                  <h2 className="text-lg font-bold text-slate-900">Your activity</h2>
                  <span className="text-xs font-medium text-slate-500">Overview</span>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <button
                    type="button"
                    onClick={() => setActiveTab('applications')}
                    className="min-w-0 rounded-2xl border border-teal-100 bg-white p-4 text-left shadow-sm transition active:scale-[0.98]"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
                      <FaBriefcase className="text-lg" />
                    </span>
                    <p className="mt-3 text-xs font-semibold text-slate-500">Applications</p>
                    <p className="mt-1 text-2xl font-extrabold text-slate-900">{applications.length}</p>
                    <p className="mt-1 text-xs text-teal-700">View status <span aria-hidden="true">→</span></p>
                  </button>

                  <button
                    type="button"
                    onClick={() => setActiveTab('saved')}
                    className="min-w-0 rounded-2xl border border-blue-100 bg-white p-4 text-left shadow-sm transition active:scale-[0.98]"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
                      <FaBookmark className="text-lg" />
                    </span>
                    <p className="mt-3 text-xs font-semibold text-slate-500">Saved Jobs</p>
                    <p className="mt-1 text-2xl font-extrabold text-slate-900">{savedJobs.length}</p>
                    <p className="mt-1 text-xs text-blue-700">View saved jobs <span aria-hidden="true">→</span></p>
                  </button>

                  <button
                    type="button"
                    onClick={() => setActiveTab('profile')}
                    className="col-span-2 flex min-w-0 items-center gap-3 rounded-2xl border border-emerald-100 bg-white p-4 text-left shadow-sm transition active:scale-[0.99]"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700">
                      <FaUser className="text-lg" />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm font-bold text-slate-800">Profile completion</span>
                      <span className="mt-1 block text-xs leading-5 text-slate-500">Keep your qualifications and skills up to date.</span>
                    </span>
                    <span className="shrink-0 text-lg font-extrabold text-emerald-700">
                    {profileCompletion}%
                  </span>
                  </button>
                </div>
              </section>

              {/* Mobile recommended jobs */}
              <section>
                <div className="mb-3 flex items-end justify-between gap-3">
                  <div>
                    <h2 className="text-lg font-bold text-slate-900">Recommended Jobs</h2>
                    <p className="mt-1 text-xs text-slate-500">Opportunities picked for you</p>
                  </div>
                  <span className="shrink-0 rounded-full bg-teal-50 px-3 py-1 text-xs font-bold text-teal-700">
                    {recommendedJobs.length} found
                  </span>
                </div>

                {recommendedJobs.length === 0 ? (
                  <div className="rounded-2xl border border-dashed border-slate-300 bg-white px-5 py-8 text-center">
                    <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-50 text-teal-700">
                      <FaBriefcase className="text-xl" />
                    </span>
                    <h3 className="mt-3 font-bold text-slate-800">No recommendations yet</h3>
                    <p className="mt-1 text-sm leading-5 text-slate-500">Update your profile skills and preferred location to see relevant jobs.</p>
                    <button type="button" onClick={() => setActiveTab('profile')} className="mt-4 rounded-xl bg-teal-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-teal-700">
                      Update Profile
                    </button>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {recommendedJobs.map((job) => (
                      <article key={job.id} className="min-w-0 overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
                        <div className="flex min-w-0 items-start gap-3">
                          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-lg font-extrabold text-teal-700">
                            {(job.institution_name || job.company_name || job.hospital || job.role || job.title || 'H').charAt(0).toUpperCase()}
                          </div>
                          <div className="min-w-0 flex-1">
                            <div className="flex flex-wrap items-start justify-between gap-2">
                              <h3 className="min-w-0 flex-1 break-words text-base font-bold leading-6 text-slate-900">
                                {job.role || job.title || 'Job Opportunity'}
                              </h3>
                              <span className="shrink-0 rounded-full bg-emerald-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-emerald-700">New</span>
                            </div>
                            <p className="mt-1 break-words text-sm text-slate-500">
                              {job.institution_name || job.company_name || job.hospital || 'Healthcare Organization'}
                            </p>
                          </div>
                        </div>

                        <div className="mt-4 space-y-2.5 border-t border-slate-100 pt-3 text-sm text-slate-600">
                          <p className="flex min-w-0 items-start gap-2.5">
                            <FaMapMarkerAlt className="mt-0.5 shrink-0 text-teal-600" />
                            <span className="break-words">{job.location || 'Location not specified'}</span>
                          </p>
                          <p className="flex min-w-0 items-start gap-2.5">
                            <FaMoneyBillWave className="mt-0.5 shrink-0 text-teal-600" />
                            <span className="break-words">{job.salary != null ? `₹${job.salary}/month` : 'Salary not specified'}</span>
                          </p>
                          {job.posted && (
                            <p className="flex min-w-0 items-start gap-2.5 text-emerald-700">
                              <FaClock className="mt-0.5 shrink-0" />
                              <span className="break-words">{job.posted}</span>
                            </p>
                          )}
                        </div>

                        <div className="mt-4 grid grid-cols-[1fr_auto] gap-2.5">
                          <button
                            type="button"
                            disabled={appliedJobs.includes(job.id)}
                            onClick={() => applyJob(job.id)}
                            className={`min-w-0 rounded-xl px-3 py-3 text-sm font-bold transition ${appliedJobs.includes(job.id) ? 'cursor-not-allowed bg-emerald-50 text-emerald-700' : 'bg-teal-600 text-white hover:bg-teal-700 active:scale-[0.98]'}`}
                          >
                            {appliedJobs.includes(job.id) ? '✓ Applied' : 'Apply Now'}
                          </button>
                          <button
                            type="button"
                            onClick={() => saveJob(job.id)}
                            aria-label={`Save ${job.role || job.title || 'job'}`}
                            className="inline-flex items-center justify-center gap-2 rounded-xl border border-teal-200 bg-white px-3 py-3 text-sm font-bold text-teal-700 transition hover:bg-teal-50 active:scale-[0.98]"
                          >
                            <FaBookmark /> <span>Save</span>
                          </button>
                        </div>
                      </article>
                    ))}
                  </div>
                )}
              </section>
            </div>

            {/* DESKTOP/TABLET DASHBOARD — original layout preserved */}
            <div className="hidden md:block">
              {/* TOP */}
              <div className="mb-6 sm:mb-8 lg:mb-10">
                <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
                  Welcome back, {user.name} 
                </h1>
                <p className="text-gray-500 mt-2 text-sm sm:text-base lg:text-lg">
                  Explore premium healthcare opportunities.
                </p>
              </div>

              {/* STATS */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 lg:gap-6 mb-6 sm:mb-8 lg:mb-10">
                <div className="bg-white rounded-3xl shadow p-4 sm:p-5 lg:p-6">
                  <p className="text-gray-500">Applications</p>
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-teal-700 mt-3">{applications.length}</h2>
                </div>
                <div className="bg-white rounded-3xl shadow p-4 sm:p-5 lg:p-6">
                  <p className="text-gray-500">Saved Jobs</p>
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-blue-700 mt-3">
                  {savedJobs.length}
                </h2>
                </div>
                <div className="bg-white rounded-3xl shadow p-4 sm:p-5 lg:p-6">
                  <p className="text-gray-500">Profile Completion</p>
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-green-700 mt-3">
                    {profileCompletion}%
                  </h2>
                </div>
              </div>

              {/* RECOMMENDED JOBS */}
              <div>
                <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-5 sm:mb-6 lg:mb-8 text-gray-800">Recommended Jobs</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
                  {recommendedJobs.map((job) => (
                    <div key={job.id} className="bg-white rounded-3xl shadow p-4 sm:p-5 lg:p-6 hover:shadow-xl transition">
                      <div className="flex justify-between items-start">
                        <div className="flex gap-4">
                          <div className="w-14 h-14 rounded-2xl bg-teal-100 flex items-center justify-center text-teal-700 text-base sm:text-lg lg:text-xl font-bold">
                            {(job.institution_name || job.company_name || job.hospital || job.role || job.title || 'H').charAt(0).toUpperCase()}
                          </div>
                          <div>
                            <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800">{job.role || job.title || 'Job Opportunity'}</h3>
                            <p className="text-gray-500 mt-1">{job.institution_name || job.company_name || 'Healthcare Organization'}</p>
                          </div>
                        </div>
                        <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-semibold">NEW</span>
                      </div>

                      <div className="mt-6 space-y-3">
                        <div className="flex items-center gap-3 text-gray-600"><FaMapMarkerAlt />{job.location || 'Location not specified'}</div>
                        <div className="flex items-center gap-3 text-gray-600">{job.salary != null ? `₹${job.salary}/month` : 'Salary not specified'}</div>
                        <div className="flex items-center gap-3 text-green-600 font-semibold"><FaClock />{job.posted}</div>
                      </div>

                      <div className="mt-8 flex gap-3">
                        <button
                          disabled={appliedJobs.includes(job.id)}
                          onClick={() => applyJob(job.id)}
                          className={`flex-1 py-3 rounded-2xl font-semibold ${appliedJobs.includes(job.id) ? 'bg-green-100 text-green-700 cursor-not-allowed' : 'bg-teal-600 text-white hover:bg-teal-700'}`}
                        >
                          {appliedJobs.includes(job.id) ? 'Applied' : 'Apply Now'}
                        </button>
                        <button
                          onClick={() => saveJob(job.id)}
                          className="border border-teal-200 rounded-2xl px-4 py-2 bg-white text-teal-700 hover:bg-teal-50 hover:border-teal-400 transition-colors duration-300"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

{activeTab === 'applications' && (
  <>

<div className="md:hidden w-full min-w-0 space-y-5">
  <div className="rounded-2xl bg-gradient-to-br from-teal-700 to-emerald-700 p-5 text-white shadow-md">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-teal-100">Your activity</p>
        <h1 className="mt-1 text-2xl font-bold">My Applications</h1>
        <p className="mt-2 text-sm leading-5 text-teal-50">Track your job applications and their latest status.</p>
      </div>
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/15">
        <FaBriefcase className="text-xl" />
      </span>
    </div>
    <div className="mt-5 flex items-end justify-between border-t border-white/20 pt-4">
      <div>
        <p className="text-sm text-teal-100">Total applications</p>
        <p className="mt-1 text-3xl font-bold">{applications.length}</p>
      </div>
      <span className="rounded-full bg-white/15 px-3 py-1.5 text-xs font-semibold">Application history</span>
    </div>
  </div>

  <div className="grid grid-cols-3 gap-2.5">
    <div className="min-w-0 rounded-xl border border-amber-100 bg-white p-3 shadow-sm">
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-50 text-amber-600"><FaClock /></span>
      <p className="mt-3 text-xs font-medium text-slate-500">Pending</p>
      <p className="mt-1 text-2xl font-bold text-slate-900">{applications.filter(app => !app.status || app.status.toLowerCase() === "pending").length}</p>
    </div>
    <div className="min-w-0 rounded-xl border border-emerald-100 bg-white p-3 shadow-sm">
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600"><FaCheckCircle /></span>
      <p className="mt-3 text-xs font-medium text-slate-500">Shortlisted</p>
      <p className="mt-1 text-2xl font-bold text-slate-900">{applications.filter(app => app.status?.toLowerCase() === "shortlisted").length}</p>
    </div>
    <div className="min-w-0 rounded-xl border border-red-100 bg-white p-3 shadow-sm">
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-50 text-red-500"><FaTimesCircle /></span>
      <p className="mt-3 text-xs font-medium text-slate-500">Rejected</p>
      <p className="mt-1 text-2xl font-bold text-slate-900">{applications.filter(app => app.status?.toLowerCase() === "rejected").length}</p>
    </div>
  </div>

  <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
    <div className="border-b border-slate-100 px-4 py-4">
      <h2 className="text-base font-bold text-slate-900">Application History</h2>
      <p className="mt-1 text-xs leading-5 text-slate-500">Your submitted applications and current status.</p>
    </div>
    {applications.length === 0 ? (
      <div className="px-5 py-10 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-50 text-teal-600"><FaBriefcase className="text-2xl" /></div>
        <h3 className="mt-4 text-base font-bold text-slate-800">No applications yet</h3>
        <p className="mx-auto mt-2 max-w-xs text-sm leading-5 text-slate-500">Your submitted job applications will appear here once you apply for a role.</p>
        <button type="button" onClick={() => setActiveTab('dashboard')} className="mt-5 inline-flex items-center justify-center rounded-xl bg-teal-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-700">Explore jobs</button>
      </div>
    ) : (
      <div className="space-y-3 p-3">
        {applications.map((app, index) => {
          const status = (app.status || "Pending").toLowerCase();
          const statusLabel = app.status || "Pending";
          const statusStyle = status === "shortlisted"
            ? "bg-emerald-50 text-emerald-700 border-emerald-200"
            : status === "rejected"
            ? "bg-red-50 text-red-700 border-red-200"
            : "bg-amber-50 text-amber-700 border-amber-200";
          const statusDot = status === "shortlisted" ? "bg-emerald-500" : status === "rejected" ? "bg-red-500" : "bg-amber-500";
          return (
            <article key={app.id || index} className="rounded-xl border border-slate-200 p-4 transition hover:border-teal-200">
              <div className="flex items-start gap-3">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-700"><FaHospital className="text-lg" /></div>
                <div className="min-w-0 flex-1">
                  <h3 className="break-words text-sm font-bold leading-5 text-slate-900 capitalize">{app.role || "Not specified"}</h3>
                  <p className="mt-1 break-words text-xs leading-5 text-slate-500">{app.organization_name || "Healthcare Organization"}</p>
                </div>
              </div>
              <div className="mt-4 flex flex-wrap items-center justify-between gap-2 border-t border-slate-100 pt-3">
                <span className="text-xs font-medium text-slate-500">Application status</span>
                <span className={`inline-flex max-w-full items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold ${statusStyle}`}>
                  <span className={`h-2 w-2 shrink-0 rounded-full ${statusDot}`} />
                  <span className="break-words">{statusLabel}</span>
                </span>
              </div>
            </article>
          );
        })}
      </div>
    )}
  </div>
</div>

<div className="hidden md:block">
  <div className="w-full space-y-7">

    {/* Header */}
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <h1 className="text-xl sm:text-2xl lg:text-3xl md:text-4xl font-bold text-slate-900">
          My Applications
        </h1>
        <p className="text-slate-500 mt-2">
          Track the status of your job applications.
        </p>
      </div>

      <div className="flex items-center gap-3 bg-white border border-slate-200 rounded-2xl px-5 py-3 shadow-sm">
        <div className="w-11 h-11 rounded-xl bg-teal-50 flex items-center justify-center">
          <FaBriefcase className="text-teal-700 text-sm sm:text-base lg:text-lg" />
        </div>
        <div>
          <p className="text-sm text-slate-500">Total Applications</p>
          <p className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-900">
            {applications.length}
          </p>
        </div>
      </div>
    </div>

    {/* Application Summary */}
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

      <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium text-slate-500">
            Pending
          </p>
          <span className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center">
            <FaClock className="text-amber-600" />
          </span>
        </div>
        <p className="text-xl sm:text-2xl lg:text-3xl font-bold text-slate-900 mt-3">
          {applications.filter(
            app => !app.status ||
              app.status.toLowerCase() === "pending"
          ).length}
        </p>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium text-slate-500">
            Shortlisted
          </p>
          <span className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center">
            <FaCheckCircle className="text-emerald-600" />
          </span>
        </div>
        <p className="text-xl sm:text-2xl lg:text-3xl font-bold text-slate-900 mt-3">
          {applications.filter(
            app => app.status?.toLowerCase() === "shortlisted"
          ).length}
        </p>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium text-slate-500">
            Rejected
          </p>
          <span className="w-10 h-10 rounded-xl bg-red-50 flex items-center justify-center">
            <FaTimesCircle className="text-red-500" />
          </span>
        </div>
        <p className="text-xl sm:text-2xl lg:text-3xl font-bold text-slate-900 mt-3">
          {applications.filter(
            app => app.status?.toLowerCase() === "rejected"
          ).length}
        </p>
      </div>

    </div>

    {/* Applications Table */}
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">

      <div className="px-3 sm:px-5 lg:px-6 py-5 border-b border-slate-200">
        <h2 className="text-sm sm:text-base lg:text-lg font-bold text-slate-900">
          Application History
        </h2>
        <p className="text-sm text-slate-500 mt-1">
          View your submitted applications and their current status.
        </p>
      </div>

      {applications.length === 0 ? (

        <div className="p-5 sm:p-8 lg:p-12 text-center">
          <div className="w-16 h-16 rounded-2xl bg-teal-50 flex items-center justify-center mx-auto mb-4">
            <FaBriefcase className="text-lg sm:text-xl lg:text-2xl text-teal-600" />
          </div>

          <h3 className="text-sm sm:text-base lg:text-lg font-bold text-slate-800">
            No applications yet
          </h3>

          <p className="text-slate-500 mt-2">
            Your submitted job applications will appear here.
          </p>
        </div>

      ) : (

        <div className="overflow-x-auto">
          <table className="w-full text-left">

            <thead className="bg-slate-50">
              <tr>
                <th className="px-3 sm:px-5 lg:px-6 py-4 text-sm font-semibold text-slate-600">
                  Job Role
                </th>
                <th className="px-3 sm:px-5 lg:px-6 py-4 text-sm font-semibold text-slate-600">
                  Hospital
                </th>
                <th className="px-3 sm:px-5 lg:px-6 py-4 text-sm font-semibold text-slate-600">
                  Status
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100">
              {applications.map((app, index) => {
                const status = (app.status || "Pending").toLowerCase();

                return (
                  <tr
                    key={app.id || index}
                    className="hover:bg-teal-50/40 transition-colors"
                  >
                    <td className="px-3 sm:px-5 lg:px-6 py-5">
                      <div className="font-semibold text-slate-800 capitalize">
                        {app.role || "Not specified"}
                      </div>
                    </td>

                    <td className="px-3 sm:px-5 lg:px-6 py-5 text-slate-600">
                      {app.organization_name || "Healthcare Organization"}
                    </td>

                    <td className="px-3 sm:px-5 lg:px-6 py-5">
                      <span
                        className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold ${
                          status === "shortlisted"
                            ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                            : status === "rejected"
                            ? "bg-red-50 text-red-700 border border-red-200"
                            : "bg-amber-50 text-amber-700 border border-amber-200"
                        }`}
                      >
                        <span className={`w-2 h-2 rounded-full ${
                          status === "shortlisted"
                            ? "bg-emerald-500"
                            : status === "rejected"
                            ? "bg-red-500"
                            : "bg-amber-500"
                        }`} />
                        {app.status || "Pending"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>

          </table>
        </div>

      )}

    </div>

  </div>
</div>
  </>
)}

        {/* PROFILE */}
       {/* PROFILE */}
{/* PROFILE */}
{activeTab === 'profile' && (

  <>
    {/* MOBILE PROFILE — mobile-only redesign; desktop profile below is preserved */}
    <div className="lg:hidden w-full min-w-0 space-y-5">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-teal-700 via-teal-600 to-emerald-600 p-5 text-white shadow-lg">
        <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-white/10" />
        <div className="absolute -right-2 bottom-[-2.5rem] h-24 w-24 rounded-full bg-white/10" />
        <div className="relative flex items-center gap-4">
          <div className="relative shrink-0">
            <img
              src={profilePic ? `${API_URL.replace('/api', '')}/${profilePic}` : `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || 'User')}&background=ccfbf1&color=0f766e`}
              alt="Profile"
              className="h-20 w-20 rounded-2xl border-2 border-white/70 object-cover shadow-md"
            />
            <span className="absolute -bottom-1 -right-1 h-5 w-5 rounded-full border-2 border-teal-700 bg-emerald-300" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-teal-100">Candidate profile</p>
            <h1 className="mt-1 break-words text-xl font-extrabold leading-tight">{user.name}</h1>
            <p className="mt-1 text-sm text-teal-50">Manage your professional details</p>
            {profile.location && <p className="mt-2 flex items-center gap-1.5 break-words text-xs text-white/90"><FaMapMarkerAlt className="shrink-0" />{profile.location}</p>}
          </div>
        </div>
        <label className="relative mt-4 inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl border border-white/40 bg-white/15 px-4 py-3 text-sm font-bold text-white transition hover:bg-white/25">
          <FaFileUpload /> Upload Profile Photo
          <input type="file" accept="image/*" className="hidden" onChange={(e) => setProfilePicFile(e.target.files[0])} />
        </label>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-1.5 shadow-sm">
        <div className="grid grid-cols-2 gap-1.5">
          <button type="button" onClick={() => setProfileTab('myProfile')} className={`rounded-xl px-2 py-3 text-sm font-bold transition ${profileTab === 'myProfile' ? 'bg-teal-600 text-white shadow-sm' : 'text-slate-600 hover:bg-teal-50'}`}>
            <span className="flex items-center justify-center gap-2"><FaUser /> My Profile</span>
          </button>
          <button type="button" onClick={() => setProfileTab('changePassword')} className={`rounded-xl px-2 py-3 text-sm font-bold transition ${profileTab === 'changePassword' ? 'bg-teal-600 text-white shadow-sm' : 'text-slate-600 hover:bg-teal-50'}`}>
            <span className="flex items-center justify-center gap-2"><FaBriefcase /> Password</span>
          </button>
        </div>
      </div>

      {profileTab === 'myProfile' && (
        <div className="space-y-4">
          <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="mb-5">
              <h2 className="text-lg font-extrabold text-slate-900">Professional Details</h2>
              <p className="mt-1 text-sm leading-5 text-slate-500">Keep your qualifications and preferences up to date.</p>
            </div>
            <div className="space-y-4">
              <div><label className="mb-1.5 block text-sm font-bold text-slate-700">Full Name</label><input type="text" value={user.name || ''} disabled className="w-full min-w-0 rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-3 text-sm text-slate-500 cursor-not-allowed" /></div>
              <div><label className="mb-1.5 block text-sm font-bold text-slate-700">Qualification</label><input type="text" name="qualification" placeholder="e.g. B.Sc Nursing, GNM" value={profile.qualification || ''} onChange={handleProfileChange} className="w-full min-w-0 rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></div>
              <div><label className="mb-1.5 block text-sm font-bold text-slate-700">Years of Experience</label><input type="text" name="experience_years" placeholder="e.g. 3 years" value={profile.experience_years || ''} onChange={handleProfileChange} className="w-full min-w-0 rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></div>
              <div><label className="mb-1.5 block text-sm font-bold text-slate-700">Preferred Location</label><input type="text" name="location" placeholder="e.g. Hyderabad" value={profile.location || ''} onChange={handleProfileChange} className="w-full min-w-0 rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></div>
              <div><label className="mb-1.5 block text-sm font-bold text-slate-700">Healthcare Skills</label><textarea name="skills" placeholder="e.g. ICU, Emergency Care, Patient Monitoring" value={profile.skills || ''} onChange={handleProfileChange} rows={3} className="w-full min-w-0 resize-y rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></div>
              <div><label className="mb-1.5 block text-sm font-bold text-slate-700">Professional Summary</label><textarea name="bio" placeholder="Briefly describe your experience, strengths, and career goals..." value={profile.bio || ''} onChange={handleProfileChange} rows={4} className="w-full min-w-0 resize-y rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></div>
            </div>
            <div className="mt-5 border-t border-slate-100 pt-4">
              <p className="mb-3 text-xs leading-5 text-slate-500">Check your details before saving your profile.</p>
              <button type="button" onClick={handleProfileSave} className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-teal-600 to-emerald-600 px-4 py-3.5 text-sm font-extrabold text-white shadow-md transition active:scale-[0.99]">Save Profile <span aria-hidden="true">→</span></button>
            </div>
          </div>
        </div>
      )}

      {profileTab === 'changePassword' && (
        <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
          <div className="mb-5"><h2 className="text-lg font-extrabold text-slate-900">Change Password</h2><p className="mt-1 text-sm leading-5 text-slate-500">Choose a strong password to keep your HireCura account secure.</p></div>
          {changePasswordMessage && <div className={`mb-4 rounded-xl border p-3 text-sm font-semibold leading-5 ${changePasswordMessageType === 'success' ? 'border-green-200 bg-green-50 text-green-700' : 'border-red-200 bg-red-50 text-red-700'}`}>{changePasswordMessageType === 'success' ? '✓ ' : '⚠ '}{changePasswordMessage}</div>}
          <div className="space-y-4">
            <div><label className="mb-1.5 block text-sm font-bold text-slate-700">Current Password</label><input type="password" autoComplete="current-password" placeholder="Enter current password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} className="w-full min-w-0 rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></div>
            <div><label className="mb-1.5 block text-sm font-bold text-slate-700">New Password</label><input type="password" autoComplete="new-password" placeholder="Enter new password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="w-full min-w-0 rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></div>
            <div><label className="mb-1.5 block text-sm font-bold text-slate-700">Confirm New Password</label><input type="password" autoComplete="new-password" placeholder="Confirm new password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full min-w-0 rounded-xl border border-slate-200 px-3.5 py-3 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-100" /></div>
          </div>
          <button type="button" onClick={handleChangePassword} disabled={changePasswordLoading} className={`mt-5 inline-flex w-full items-center justify-center rounded-xl px-4 py-3.5 text-sm font-extrabold text-white transition ${changePasswordLoading ? 'cursor-not-allowed bg-teal-400 opacity-70' : 'bg-teal-600 hover:bg-teal-700 active:scale-[0.99]'}`}>{changePasswordLoading ? 'Changing Password...' : 'Update Password'}</button>
        </div>
      )}
    </div>

    {/* DESKTOP PROFILE — original layout preserved */}
    <div className="hidden lg:block bg-white rounded-3xl shadow p-4 sm:p-6 lg:p-8 max-w-5xl">

    {/* PROFILE HEADER */}
    <div className="mb-5 sm:mb-6 lg:mb-8">

      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
        Profile
      </h1>

      <p className="text-gray-500 mt-2">
        Manage your personal information and account security.
      </p>

    </div>


    {/* PROFILE SUB TABS */}
    <div className="flex gap-3 border-b mb-5 sm:mb-6 lg:mb-8">

      <button
        onClick={() => setProfileTab('myProfile')}
        className={`px-3 sm:px-5 lg:px-6 py-3 font-semibold transition ${
          profileTab === 'myProfile'
            ? 'text-teal-700 border-b-2 border-teal-600'
            : 'text-gray-500 hover:text-teal-700'
        }`}
      >
        My Profile
      </button>


     <button
  type="button"
  onClick={() => setProfileTab('changePassword')}
  className={`px-3 sm:px-5 lg:px-6 py-3 font-semibold transition ${
    profileTab === 'changePassword'
      ? 'text-teal-700 border-b-2 border-teal-600'
      : 'text-gray-500 hover:text-teal-700'
  }`}
>
  Change Password
</button>

    </div>


{/* MY PROFILE */}
{profileTab === 'myProfile' && (
  <div className="space-y-8">

    {/* Profile Header Card */}
    <div className="bg-gradient-to-r from-teal-50 to-emerald-50
                    border border-teal-100 rounded-3xl p-4 sm:p-5 lg:p-6 md:p-8">

      <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 lg:gap-6">

        {/* Profile Picture */}
        <div className="flex flex-col items-center shrink-0">
          <div className="relative">
            <img
              src={
                profilePic
                  ? `${API_URL.replace('/api', '')}/${profilePic}`
                  : `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || 'User')}&background=ccfbf1&color=0f766e`
              }
              alt="Profile"
              className="w-28 h-28 rounded-full object-cover
                         border-4 border-white shadow-md"
            />

            <span className="absolute bottom-1 right-1 w-5 h-5
                             rounded-full bg-emerald-500
                             border-2 border-white" />
          </div>

          <label className="mt-4 px-4 py-2 rounded-xl bg-white
                            border border-teal-200 text-teal-700
                            text-sm font-semibold cursor-pointer
                            hover:bg-teal-600 hover:text-white
                            transition-colors duration-200">
            Upload Photo
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={(e) => setProfilePicFile(e.target.files[0])}
            />
          </label>
        </div>

        {/* Basic Information */}
        <div className="text-center sm:text-left flex-1 min-w-0">
          <p className="text-sm font-semibold text-teal-700 mb-2">
            CANDIDATE PROFILE
          </p>

          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-800 break-words">
            {user.name}
          </h3>

          <p className="text-slate-500 mt-2">
            Keep your professional information up to date
          </p>

          {profile.location && (
            <p className="text-sm text-slate-600 mt-3">
              <span className="mr-2">📍</span>
              {profile.location}
            </p>
          )}
        </div>
      </div>
    </div>

    {/* Personal & Professional Details */}
    <div className="bg-white border border-slate-200
                    rounded-3xl p-4 sm:p-5 lg:p-6 md:p-8">

      <div className="mb-7">
        <h3 className="text-base sm:text-lg lg:text-xl font-bold text-slate-800">
          Professional Details
        </h3>
        <p className="text-sm text-slate-500 mt-1">
          Add your qualifications and healthcare experience.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">

        {/* Full Name */}
        <div>
          <label className="block text-sm font-semibold
                            text-slate-700 mb-2">
            Full Name
          </label>
          <input
            type="text"
            value={user.name || ''}
            disabled
            className="w-full border border-slate-200 p-4
                       rounded-xl bg-slate-50 text-slate-500
                       cursor-not-allowed"
          />
        </div>

        {/* Qualification */}
        <div>
          <label className="block text-sm font-semibold
                            text-slate-700 mb-2">
            Qualification
          </label>
          <input
            type="text"
            name="qualification"
            placeholder="e.g. B.Sc Nursing, GNM"
            value={profile.qualification || ''}
            onChange={handleProfileChange}
            className="w-full border border-slate-200 p-4
                       rounded-xl bg-white
                       focus:outline-none focus:ring-2
                       focus:ring-teal-500 focus:border-teal-100
                       transition"
          />
        </div>

        {/* Experience */}
        <div>
          <label className="block text-sm font-semibold
                            text-slate-700 mb-2">
            Years of Experience
          </label>
          <input
            type="text"
            name="experience_years"
            placeholder="e.g. 3 years"
            value={profile.experience_years || ''}
            onChange={handleProfileChange}
            className="w-full border border-slate-200 p-4
                       rounded-xl bg-white
                       focus:outline-none focus:ring-2
                       focus:ring-teal-500 focus:border-teal-100
                       transition"
          />
        </div>

        {/* Location */}
        <div>
          <label className="block text-sm font-semibold
                            text-slate-700 mb-2">
            Preferred Location
          </label>
          <input
            type="text"
            name="location"
            placeholder="e.g. Hyderabad"
            value={profile.location || ''}
            onChange={handleProfileChange}
            className="w-full border border-slate-200 p-4
                       rounded-xl bg-white
                       focus:outline-none focus:ring-2
                       focus:ring-teal-500 focus:border-teal-100
                       transition"
          />
        </div>
      </div>

      {/* Skills */}
      <div className="mt-6">
        <label className="block text-sm font-semibold
                          text-slate-700 mb-2">
          Healthcare Skills
        </label>
        <textarea
          name="skills"
          placeholder="e.g. ICU, Emergency Care, Patient Monitoring"
          value={profile.skills || ''}
          onChange={handleProfileChange}
          rows={3}
          className="w-full border border-slate-200 p-4
                     rounded-xl resize-y
                     focus:outline-none focus:ring-2
                     focus:ring-teal-500 focus:border-teal-100
                     transition"
        />
       
      </div>

      {/* Professional Summary */}
      <div className="mt-6">
        <label className="block text-sm font-semibold
                          text-slate-700 mb-2">
          Professional Summary
        </label>
        <textarea
          name="bio"
          placeholder="Briefly describe your experience, strengths, and career goals..."
          value={profile.bio || ''}
          onChange={handleProfileChange}
          rows={4}
          className="w-full border border-slate-200 p-4
                     rounded-xl resize-y
                     focus:outline-none focus:ring-2
                     focus:ring-teal-500 focus:border-teal-100
                     transition"
        />
      </div>

      {/* Save Actions */}
      <div className="flex flex-col sm:flex-row sm:items-center
                      justify-between gap-4 mt-8 pt-6
                      border-t border-slate-100">

        <p className="text-sm text-slate-500">
          Make sure your details are accurate before saving.
        </p>

        <button
          onClick={handleProfileSave}
          className="inline-flex items-center justify-center
                     gap-2 bg-gradient-to-r from-teal-600
                     to-emerald-600 text-white px-4 sm:px-6 lg:px-8 py-4
                     rounded-xl font-semibold shadow-md
                     hover:from-teal-700 hover:to-emerald-700
                     hover:shadow-lg hover:-translate-y-0.5
                     transition-all duration-200"
        >
          Save Profile
          <span aria-hidden="true">→</span>
        </button>
      </div>

    </div>
  </div>
)}



    {/* CHANGE PASSWORD */}
    {profileTab === 'changePassword' && (

      <div className="max-w-xl">

        <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 mb-2">
          Change Password
        </h2>

        <p className="text-gray-500 mb-5 sm:mb-6 lg:mb-8">
          Update your password to keep your HireCura account secure.
        </p>


        <div className="space-y-5">
          {changePasswordMessage && (
              <div
                className={`mb-6 p-4 rounded-2xl font-semibold ${
                  changePasswordMessageType === "success"
                    ? "bg-green-100 text-green-700 border border-green-200"
                    : "bg-red-100 text-red-700 border border-red-200"
                }`}
              >
                {changePasswordMessageType === "success"
                  ? "✓ "
                  : "⚠ "}
                {changePasswordMessage}
              </div>
            )}

          <div>
            <label className="block font-semibold text-gray-700 mb-2">
              Current Password
            </label>

                        <input
              type="password"
              placeholder="Enter current password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="w-full border p-4 rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>


          <div>
            <label className="block font-semibold text-gray-700 mb-2">
              New Password
            </label>

            <input
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full border p-4 rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>


          <div>
            <label className="block font-semibold text-gray-700 mb-2">
              Confirm New Password
            </label>

            <input
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full border p-4 rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>


          <button
  type="button"
  onClick={handleChangePassword}
  disabled={changePasswordLoading}
  className={`bg-teal-600 text-white px-4 sm:px-6 lg:px-8 py-4 rounded-2xl font-bold transition ${
    changePasswordLoading
      ? "opacity-60 cursor-not-allowed"
      : "hover:bg-teal-700"
  }`}
>
  {changePasswordLoading
    ? "Changing Password..."
    : "Change Password"}
</button>

        </div>

      </div>

    )}

  </div>
  </>

)}

{/* RESUME */}

{/* RESUME */}
{activeTab === 'resume' && (
  <div className="bg-white rounded-3xl shadow p-4 sm:p-6 lg:p-10 text-center">

    <div className="space-y-8">

      {/* Resume Upload Card */}
      <div className="max-w-2xl mx-auto text-center">

        <h2 className="text-lg sm:text-xl lg:text-2xl md:text-3xl font-bold
                       text-slate-800 mt-6">
          Upload Resume
        </h2>

        <p className="text-slate-500 mt-3 leading-6">
          Upload your latest resume to help healthcare employers
          understand your qualifications and experience.
        </p>

        {/* File Picker */}
        <div className="mt-8 p-4 sm:p-5 lg:p-6 rounded-2xl border-2
                        border-dashed border-teal-200 bg-teal-50/50
                        hover:border-teal-400 hover:bg-teal-50
                        transition-colors duration-300">

          <FaFileAlt className="text-xl sm:text-2xl lg:text-3xl text-teal-600
                                mx-auto mb-4" />

          <p className="font-semibold text-slate-700 mb-2">
            Choose your resume file
          </p>

          <p className="text-sm text-slate-500 mb-5">
            Supported formats: PDF, DOC, DOCX
          </p>

          {/* Centered File Input */}
          <div className="flex justify-center w-full">
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleResumeUpload}
              className="block w-fit max-w-full mx-auto
                         text-sm text-slate-600
                         file:mr-4 file:py-3 file:px-5
                         file:rounded-xl file:border-0
                         file:bg-teal-600 file:text-white
                         file:font-semibold
                         hover:file:bg-teal-700
                         file:cursor-pointer file:transition-colors
                         file:duration-200 cursor-pointer"
            />
          </div>

        </div>

        {/* Supporting Information */}
        <div className="flex flex-col sm:flex-row
                        items-center justify-center gap-3
                        mt-6 text-sm text-slate-500">

          <span className="flex items-center gap-2">
            <FaCheckCircle className="text-emerald-500" />
            PDF and Word documents
          </span>

          <span className="hidden sm:inline text-slate-300">•</span>

          <span>Keep your resume up to date</span>

        </div>

      </div>
    </div>

    {/* Resume Uploaded — Minimal Design */}
    {resumeUrl && (
      <div className="mt-6 inline-flex flex-col sm:flex-row
                      items-center justify-center gap-3
                      bg-emerald-50 border border-emerald-100
                      rounded-xl px-5 py-4">

        {/* Upload Status */}
        <div className="flex items-center gap-2">
          <FaCheckCircle className="text-emerald-600 text-sm sm:text-base lg:text-lg" />

          <span className="text-sm font-semibold text-emerald-700">
            Resume Uploaded
          </span>
        </div>

        <span className="hidden sm:block text-slate-300">|</span>

        {/* View Resume */}
        <a
          href={`${API_URL.replace('/api', '')}/${resumeUrl}`}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2
                     text-sm font-semibold text-teal-700
                     hover:text-teal-900 transition-colors"
        >
          <FaExternalLinkAlt className="text-xs" />
          View Resume
        </a>

      </div>
    )}

  </div>
)}


      
{/* NOTIFICATIONS */}
{activeTab === 'notifications' && (
  <>
    {/* MOBILE NOTIFICATIONS — desktop layout below is preserved */}
    <section className="lg:hidden w-full min-w-0 space-y-5 pb-5">
      <div className="overflow-hidden rounded-2xl bg-gradient-to-r from-teal-700 to-emerald-600 p-5 text-white shadow-md">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/20">
            <FaBell className="text-xl" />
          </div>
          <div className="min-w-0 flex-1">
            <h1 className="text-xl font-bold">Notifications</h1>
            <p className="mt-1 text-sm leading-5 text-teal-50">Stay up to date with your application activity</p>
          </div>
          <button type="button" onClick={fetchNotifications} aria-label="Refresh notifications" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/20 transition active:scale-95 hover:bg-white/30">
            <FaClock className="text-lg" />
          </button>
        </div>
        <div className="mt-4 flex items-center justify-between rounded-xl bg-white/15 px-4 py-3">
          <span className="text-sm font-medium">Total notifications</span>
          <span className="rounded-lg bg-white px-3 py-1 text-lg font-bold text-teal-700">{notifications.length}</span>
        </div>
      </div>

      {notifications.length === 0 ? (
        <div className="rounded-2xl border border-slate-200 bg-white px-5 py-9 text-center shadow-sm">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-teal-50">
            <FaBell className="text-2xl text-teal-600" />
          </div>
          <h2 className="text-base font-bold text-slate-800">You’re all caught up!</h2>
          <p className="mx-auto mt-2 max-w-xs text-sm leading-6 text-slate-500">Updates from employers and your applications will appear here.</p>
          <button type="button" onClick={fetchNotifications} className="mt-5 inline-flex items-center justify-center gap-2 rounded-xl bg-teal-700 px-5 py-3 text-sm font-semibold text-white transition hover:bg-teal-800 active:scale-[0.98]">
            <FaBell /> Check again
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          <div className="flex items-center justify-between px-1">
            <h2 className="text-base font-bold text-slate-800">Recent updates</h2>
            <span className="text-xs font-medium text-slate-500">{notifications.length} {notifications.length === 1 ? 'update' : 'updates'}</span>
          </div>
          {notifications.map((notification) => (
            <article key={notification.id}
              className="flex min-w-0 items-start gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition hover:border-teal-200 hover:bg-teal-50/60">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
                <FaBell className="text-lg" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="break-words text-sm font-semibold leading-6 text-slate-800">{notification.message}</p>
                {notification.created_at && <p className="mt-2 text-xs leading-5 text-slate-500">{new Date(notification.created_at).toLocaleString()}</p>}
              </div>
            </article>
          ))}
        </div>
      )}


    </section>

    <div className="hidden lg:block bg-white rounded-3xl shadow p-4 sm:p-6 lg:p-8">
    <div className="flex items-center justify-between mb-5 sm:mb-6 lg:mb-8">
      <h1 className="text-xl sm:text-2xl lg:text-3xl md:text-4xl font-bold">
        Notifications
      </h1>

      <button
        onClick={fetchNotifications}
        className="px-4 py-2 rounded-xl bg-teal-600
                   text-white hover:bg-teal-700"
      >
        Refresh
      </button>
    </div>

    {notifications.length === 0 ? (
      <div className="text-center py-12">
        <p className="text-gray-500 text-sm sm:text-base lg:text-lg">
          No notifications yet.
        </p>
        <p className="text-gray-400 mt-2">
          Updates from employers will appear here.
        </p>
      </div>
    ) : (
      <div className="space-y-4">
        {notifications.map((notification) => (
  <div
    key={notification.id}
    onClick={() => handleNotificationClick(notification)}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleNotificationClick(notification);
      }
    }}
    className="border border-slate-200 rounded-2xl
               p-5 hover:bg-teal-50 cursor-pointer
               transition-colors"
  >
    <div className="flex items-start gap-3">
      <div className="text-lg sm:text-xl lg:text-2xl">🔔</div>

      <div className="flex-1">
        <h3 className="font-bold text-sm sm:text-base lg:text-lg text-slate-800">
          {notification.message}
        </h3>

        {notification.created_at && (
          <p className="text-sm text-gray-500 mt-2">
            {new Date(notification.created_at).toLocaleString()}
          </p>
        )}
      </div>
    </div>
  </div>
))}
      </div>
    )}
  {selectedApplication && (
  <div
    id="selected-application-card"
    className="mt-8 border border-teal-200
               rounded-2xl bg-white p-4 sm:p-5 lg:p-6 shadow-sm"
  >

    <div className="flex items-start justify-between gap-4">
      <div>
        <p className="text-sm font-semibold text-teal-700">
          YOUR APPLICATION
        </p>

        <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-slate-900 mt-2">
          {selectedApplication.role || 'Job Role'}
        </h2>

        <p className="text-slate-600 mt-2">
          {selectedApplication.organization_name ||
            'Healthcare Organization'}
        </p>
      </div>

      <button
        onClick={() => setSelectedApplication(null)}
        className="text-slate-500 hover:text-slate-800
                   text-base sm:text-lg lg:text-xl"
        aria-label="Close job details"
      >
        ✕
      </button>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
      <div className="rounded-xl bg-slate-50 p-4">
        <p className="text-sm text-slate-500">Location</p>
        <p className="font-semibold text-slate-800 mt-1">
          {selectedApplication.location || 'Not specified'}
        </p>
      </div>

      <div className="rounded-xl bg-slate-50 p-4">
        <p className="text-sm text-slate-500">Salary</p>
        <p className="font-semibold text-slate-800 mt-1">
          {selectedApplication.salary || 'Not specified'}
        </p>
      </div>

      <div className="rounded-xl bg-slate-50 p-4 sm:col-span-2">
        <p className="text-sm text-slate-500">
          Application Status
        </p>
        <p className="font-semibold text-teal-700 mt-1">
          {selectedApplication.status || 'Pending'}
        </p>
      </div>
    </div>

    <p className="text-sm text-slate-500 mt-5">
      Application ID: {selectedApplication.id}
    </p>

  </div>
)}
    </div>
  </>
)}



{/* SAVED JOBS */}
{activeTab === 'saved' && (
  <>
    {/* MOBILE SAVED JOBS — desktop layout below remains unchanged */}
    <section className="lg:hidden w-full min-w-0 space-y-5 pb-5">
      <div className="rounded-2xl bg-gradient-to-r from-teal-700 to-emerald-600 p-5 text-white shadow-md">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/20">
            <FaBookmark className="text-xl" />
          </div>
          <div className="min-w-0">
            <h1 className="text-xl font-bold">Saved Jobs</h1>
            <p className="mt-1 text-sm text-teal-50">Your shortlisted healthcare opportunities</p>
          </div>
        </div>
        <div className="mt-4 flex items-center justify-between rounded-xl bg-white/15 px-4 py-3">
          <span className="text-sm font-medium">Total saved jobs</span>
          <span className="rounded-lg bg-white px-3 py-1 text-lg font-bold text-teal-700">{savedJobs.length}</span>
        </div>
      </div>

      {savedJobs.length === 0 ? (
        <div className="rounded-2xl border border-slate-200 bg-white px-5 py-9 text-center shadow-sm">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-teal-50">
            <FaBookmark className="text-2xl text-teal-600" />
          </div>
          <h2 className="text-base font-bold text-slate-800">No Saved Jobs Yet</h2>
          <p className="mx-auto mt-2 max-w-xs text-sm leading-6 text-slate-500">Save interesting opportunities from the dashboard and they’ll appear here.</p>
          <button type="button" onClick={() => setActiveTab('dashboard')} className="mt-5 inline-flex items-center justify-center gap-2 rounded-xl bg-teal-700 px-5 py-3 text-sm font-semibold text-white transition hover:bg-teal-800">
            <FaBriefcase /> Explore Jobs
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          {savedJobs.map((job) => (
            <article key={job.saved_job_id} className="min-w-0 overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-shadow hover:shadow-md">
              <div className="flex min-w-0 items-start gap-3">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
                  <FaHospital className="text-xl" />
                </div>
                <div className="min-w-0 flex-1">
                  <h2 className="break-words text-base font-bold capitalize leading-snug text-slate-900">{job.role || job.title || 'Job Opportunity'}</h2>
                  <p className="mt-1 break-words text-sm font-medium text-slate-600">{job.institution_name || 'Healthcare Organization'}</p>
                </div>
                <span className="shrink-0 rounded-full bg-teal-50 px-2.5 py-1 text-xs font-semibold text-teal-700">Saved</span>
              </div>

              <div className="mt-4 space-y-3 border-t border-slate-100 pt-4">
                <div className="flex min-w-0 items-start gap-3 text-sm text-slate-600">
                  <FaMapMarkerAlt className="mt-0.5 shrink-0 text-teal-600" />
                  <span className="break-words">{job.location || 'Location not specified'}</span>
                </div>
                <div className="flex min-w-0 items-start gap-3 text-sm text-slate-600">
                  <FaMoneyBillWave className="mt-0.5 shrink-0 text-teal-600" />
                  <span className="break-words font-semibold text-slate-800">{job.salary != null ? `₹${job.salary}` : 'Salary not specified'}</span>
                </div>
              </div>

              <div className="mt-5 grid grid-cols-2 gap-3">
                <button type="button" onClick={() => navigate(`/job/${job.job_id}`)} className="flex min-w-0 items-center justify-center gap-2 rounded-xl bg-teal-700 px-3 py-3 text-sm font-semibold text-white transition hover:bg-teal-800">
                  <FaEye className="shrink-0" /> <span>View Job</span>
                </button>
                <button type="button" onClick={() => removeSavedJob(job.saved_job_id)} className="flex min-w-0 items-center justify-center gap-2 rounded-xl border border-red-200 bg-white px-3 py-3 text-sm font-semibold text-red-600 transition hover:bg-red-50">
                  <FaTrashAlt className="shrink-0" /> <span>Remove</span>
                </button>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>

    {/* DESKTOP SAVED JOBS — original layout preserved */}
{/* SAVED JOBS */}
{activeTab === 'saved' && (
  <div className="hidden lg:block min-h-full bg-slate-100 p-2 sm:p-4 md:p-8">

    <div className="max-w-7xl mx-auto">

      {/* Heading */}
      <h1 className="text-xl sm:text-2xl lg:text-3xl md:text-4xl font-bold text-slate-900 mb-5 sm:mb-6 lg:mb-8">
        Saved Jobs
      </h1>

      {/* Empty State */}
      {savedJobs.length === 0 ? (
        <div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-4 sm:p-6 lg:p-10 md:p-12 text-center">

          <FaBookmark className="text-3xl sm:text-4xl lg:text-5xl mx-auto text-teal-600 mb-5" />

          <h2 className="text-base sm:text-lg lg:text-xl font-bold text-slate-800">
            No Saved Jobs
          </h2>

          <p className="text-gray-500 mt-2">
            Jobs you save will appear here.
          </p>

        </div>
      ) : (

        /* Saved Jobs List */
        <div className="space-y-5">

          {savedJobs.map((job) => (
            <div
              key={job.saved_job_id}
              className="bg-white rounded-3xl border border-slate-200 shadow-sm hover:shadow-md transition-all duration-200 p-4 sm:p-5 lg:p-6 md:p-8"
            >

              <div className="flex flex-col md:flex-row md:items-center gap-4 sm:gap-5 lg:gap-6">

                {/* Job Information */}
                <div className="flex-1 min-w-0">

                  <h2 className="text-base sm:text-lg lg:text-xl md:text-2xl font-bold capitalize text-slate-900 break-words">
                    {job.role || job.title || "Job Opportunity"}
                  </h2>

                  <p className="flex items-center gap-3 text-slate-500 mt-4">
                    <FaBuilding className="text-teal-600 shrink-0" />
                    <span className="text-sm sm:text-base lg:text-lg font-semibold text-slate-800">
                      {job.institution_name || "Not specified"}
                    </span>
                  </p>

                  <p className="flex items-center gap-3 text-slate-500 mt-3">
                    <FaMapMarkerAlt className="text-teal-600 shrink-0" />
                    <span className="text-sm sm:text-base lg:text-lg font-semibold text-slate-800">
                      {job.location || "Not specified"}
                    </span>
                  </p>

                  <p className="flex items-center gap-3 text-sm sm:text-base lg:text-lg font-bold text-emerald-600 mt-4">
                    <FaMoneyBillWave className="shrink-0" />
                    <span className="text-sm sm:text-base lg:text-lg font-semibold text-slate-800">
                      {job.salary != null
                        ? `₹${job.salary}`
                        : "Salary not specified"}
                    </span>
                  </p>

                </div>

                {/* Divider */}
                <div className="hidden md:block self-stretch border-l border-slate-200" />

                {/* Action Buttons */}
                <div className="flex gap-3 md:flex-col md:w-48 shrink-0">

                  <button
                    type="button"
                    onClick={() => navigate(`/job/${job.job_id}`)}
                    className="flex-1 flex items-center justify-center gap-2 bg-teal-700 hover:bg-teal-800 text-white font-semibold px-4 py-3 rounded-xl transition"
                  >
                    <FaEye />
                    View Job
                  </button>

                  <button
                    type="button"
                    onClick={() => removeSavedJob(job.saved_job_id)}
                    className="flex-1 flex items-center justify-center gap-2 bg-white border border-red-200 text-red-600 hover:bg-red-50 font-semibold px-4 py-3 rounded-xl transition"
                  >
                    <FaTrashAlt />
                    Remove
                  </button>

                </div>

              </div>
            </div>
          ))}

        </div>
      )}

    </div>
  </div>
)}
  </>
)}
</div>
</div>
  );
}

export default CandidateDashboard;